module.exports = __webpack_public_path__ + "static/media/prod-cta-pride-4t-sae-20w-50.f41c27f0.png";